export const EconsultUserRoles = {
  consultant: 'CONSULTANT',
  consultantDelegate: 'DELEGATE_OF_CONSULTANT',
  referrer: 'REFERRER',
  referrerDelegate: 'DELEGATE_OF_REFERRER',
  triage: 'TRIAGE'
};
